import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import { SectionContentLinkList } from 'components/section-content-link-list';
import { SectionContentLinkListIdFour } from 'components/section-content-link-list/section-content-link-list.enums';

export const TabFourContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdFour.OurCommitmentsToYou,
      text: sections.tabFourSection.tab.contents.item1(),
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabFourSection.tab.title(),
      subTitle: sections.tabFourSection.tab.text(),
    },
    columnRight: {
      title: sections.tabFourSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-04/tab-04-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
